import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'tm-page-not-found',
    templateUrl: './tm-page-not-found.component.html',
    styleUrls: ['./tm-page-not-found.component.scss']
})
export class TmPageNotFoundComponent implements OnInit {
    tradeMeUrl: string;

    constructor(public _activatedRoute: ActivatedRoute) {}

    ngOnInit(): void {
        this.tradeMeUrl = this._activatedRoute.snapshot.data.tradeMeUrl;
    }
}
